import React from "react";

/** Compact ⓘ tip — prefers title tooltip; no long hint paragraphs. */
export default function InfoHint({ title, label = "More info" }) {
  return (
    <span
      title={title}
      aria-label={label}
      className="inline-flex h-3.5 w-3.5 shrink-0 cursor-help items-center justify-center rounded-full text-[10px] font-semibold leading-none text-[hsl(var(--ds-muted-fg))] hover:text-[hsl(var(--ds-fg))]"
    >
      ⓘ
    </span>
  );
}
